
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"24","viewBox":"0 0 23 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.956 6.628a.74.74 0 00-.559-.516l-1.52-.306-.76-1.403A.73.73 0 0019.48 4a.714.714 0 00-.636.387L18.1 5.79l-1.52.306a.714.714 0 00-.559.516.836.836 0 00.155.758l1.055 1.177-.186 1.596a.773.773 0 00.295.71.73.73 0 00.744.08l1.397-.677 1.396.677a.671.671 0 00.31.065c.155 0 .31-.049.434-.145a.773.773 0 00.295-.71l-.186-1.596 1.055-1.177a.762.762 0 00.17-.742zm-2.11 1.29a.731.731 0 00-.186.613l.14 1.145-1.009-.484a.7.7 0 00-.62 0l-1.009.484.14-1.145a.785.785 0 00-.186-.613l-.76-.838 1.085-.226a.687.687 0 00.497-.387l.543-1 .543 1a.726.726 0 00.496.37l1.086.227-.76.854z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M17.988 8.5l-1-1.5 1.5-1 1-1.5.5 1 1 1 1.5.5-1.5 1.5.5 1-.5 1-1.5-1-1.5.5V8.5zM19.23 17.7c-.6-.082-1.202-.246-1.804-.438a10.047 10.047 0 01-5.825-5.113c-1.203-2.434-1.367-5.169-.492-7.74a8.667 8.667 0 01.766-1.695c.328-.601.3-1.34-.082-1.887a1.74 1.74 0 00-1.723-.71C5.066.963 1.21 4.71.225 9.686c-1.039 5.278 1.586 10.61 6.4 12.99a12.302 12.302 0 005.414 1.285c2.953 0 5.852-1.094 8.149-3.227a1.71 1.71 0 00.465-1.805c-.191-.656-.738-1.12-1.422-1.23zM7.473 21.009C3.48 19.039 1.21 14.446 2.085 10.07c.82-4.129 3.938-7.246 8.012-8.012-.3.574-.574 1.176-.793 1.805-1.039 3.035-.82 6.29.602 9.16 1.422 2.845 3.856 5.005 6.891 6.044.63.219 1.258.383 1.914.492-3.09 2.735-7.492 3.31-11.239 1.45z","fill":"currentColor"}})])
          )
        }
      }
    